import PopupWindow from './PopupWindow.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'popupWindow', PopupWindow);
  },
};
